module.exports = __webpack_public_path__ + "img/duck_dim.2084990e.svg";